import React from 'react';
import { Link } from 'react-router-dom';

const Impressum: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Impressum</h1>
        
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          Rätseljagd TU Braunschweig<br />
          Max Oppermann i.A. Fachgruppe Informatik<br />
          Technische Universität Braunschweig<br />
          Mühlenpfordtstraße 23<br />
          38106 Braunschweig
        </p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: fginfo(at)tu-bs.de
        </p>

        <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
        <p>
          Max Oppermann i.A. Fachgruppe Informatik<br />
          Technische Universität Braunschweig<br />
          Fachgruppenraum (IZ 149/150) <br />
          Mühlenpfordtstraße 23<br />
          38106 Braunschweig
        </p>

        <h2>Haftungsausschluss</h2>
        
        <h3>Haftung für Inhalte</h3>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
          Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
          nach den allgemeinen Gesetzen verantwortlich.
        </p>

        <h3>Haftung für Links</h3>
        <p>
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen 
          Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
          Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
          Seiten verantwortlich.
        </p>

        <h3>Urheberrecht</h3>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
          dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
          der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
          Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>

        <div className="back-link">
          <Link to="/">← Zurück zur Startseite</Link>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
